<ion-header>
  <ion-toolbar class="new-background-color">
    <ion-buttons class="ionnavbtns" slot="start">
      <ion-button style="color:white" (click)="cancel()">Cancel</ion-button>
    </ion-buttons>

    <ion-title class="ion-text-center"  style="color: white;">Signature Verification</ion-title>

  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding" >
  
  <h5>Member Attestation of Record</h5>
  <p style="font-size: 15px;font-weight: 500">I certify that I received the reported transformation services noted in
    the mileage log with the driver
    listed in the log. </p>
  <h6 style="text-decoration: underline">It is a federal crime to provide false information. Your signature verifies
    the time and services rendered
    are accurate and that the transportation services were provided.</h6>

      <div class="signature-container" [style.width]="deviceWidth"> 
        <canvas #signatureCanvas [style.width]="deviceWidth" style="border: 1px solid #ccc; touch-action: none; height: 200px; background-color: white;"></canvas>
      </div>
  <!-- <img src='{{ signatureImg }}' /> -->
  <p style="text-align: center;color: grey">Sign your name using your finger.</p>
  <div class="container">
    <ion-button fill="clear" (click)="clearPad();">Clear Signature</ion-button>
  </div>
  
  <div class="button-container">
    <ion-button expand="full" color="secondary" (click)="submit()" [disabled]="!drawstart">Submit</ion-button>
  </div>
  
</ion-content>

